<script>
import SKLink from './index.vue';

export {
    SKLink,
};

export default SKLink;

</script>
